import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Schedule from '../views/Schedule.vue';
import GenericForm from '@/modules/form/components/GenericForm.vue';
import CurrentGroups from '@/views/CurrentGroups.vue';
import Register from '../views/Register.vue';
import Login from '../views/Login.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Schedule,
        // component: Home,
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    },
    {
        // path: '/registration/', // use to release for zoukwroclove.pl with DNN
        // path: '/registration/', // use to release for zoukwroclove.pl with DNN
        path: '/schedule',
        component: Schedule,
        children: [
            {
                path: '/f',
                component: () => import(/* webpackChunkName: "form" */ '../views/Form.vue'),
            },
        ],
    },
    {
        // path: '/registration/form', // use to release for zoukwroclove.pl with DNN
        path: '/form',
        name: 'form',
        component: GenericForm,
    },
    {
        // path: '/registration/currentgroups', // use to release for zoukwroclove.pl with DNN
        path: '/currentgroups',
        name: 'currentgroups',
        component: CurrentGroups,
    },
    {
        // path: '/registration/register', // use to release for zoukwroclove.pl with DNN
        path: '/register',
        name: 'register',
        component: Register,
    },
    {
        // path: '/registration/register', // use to release for zoukwroclove.pl with DNN
        path: '/login',
        name: 'login',
        component: Login,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
